// Mozi Wash Sticky Bar: shown once the first section on the page has scrolled
// out of view, hidden again while the buy button inside the button's target
// (e.g. #buybox) is on screen. Re-checked on scroll and resize, once per frame.
(function () {
  function init(bar) {
    if (!bar || bar.dataset.mwStickyReady) return;
    bar.dataset.mwStickyReady = 'true';

    var host = bar.closest('.shopify-section');
    var main = document.getElementById('MainContent') || document.body;
    var first = Array.prototype.find.call(
      main.querySelectorAll('.shopify-section'),
      function (s) { return s !== host && s.offsetHeight > 0; }
    );

    var btn = bar.querySelector('[data-mw-scroll]');
    var hash = btn ? btn.getAttribute('href') || '' : '';
    var target = hash.charAt(0) === '#' && hash.length > 1 ? document.getElementById(hash.slice(1)) : null;
    // What hides the bar is the target's own buy button being on screen, not
    // the whole section: the SKO offer's CTA, else the first button-like
    // element inside the target, else the target itself.
    if (target) {
      target =
        target.querySelector('[data-sko-cta]') ||
        target.querySelector('button[type="submit"], [name="add"], .skp-btn') ||
        target;
    }

    var focusables = bar.querySelectorAll('a');
    var ticking = false;

    function update() {
      ticking = false;
      var pastFirst = first ? first.getBoundingClientRect().bottom <= 0 : window.scrollY > 0;
      var overTarget = false;
      if (target) {
        var r = target.getBoundingClientRect();
        overTarget = r.top < window.innerHeight && r.bottom > 0;
      }
      var show = pastFirst && !overTarget;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      focusables.forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    }

    function request() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-mw-sticky]').forEach(init);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-mw-sticky]'));
  });
})();
